// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2Wlfc","col":"Table_col__31lRY","fulfillmentStatus":"Table_fulfillmentStatus__2M0c8","emailCol":"Table_emailCol__1dnFQ"};